var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Coins","storeName":"Coins","labelAddNew":"Agregar","canAdd":false,"canEdit":true,"canDelete":false,"sortable":"","next-link":"/admin/liquidations","breadcrumbs":[
      {
        text: 'Finanzas',
        disabled: false,
        href: '/admin/coins'
      },
      {
        text: 'Coins',
        disabled: false,
        href: '#'
      }
      
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }